import type { FiltersConfig } from '@openx/types/chipFilters.ts';
import type { DealsListFiltersValue, ListDeal, ListDealBase } from '@openx/types/deal.ts';
import type { ToggleSelect } from '@openx/types/selectableTable.ts';
import type { AllTableCriteria } from '@openx/types/tableCriteria.ts';
import type { RowAction } from '@openx/types/tableHelpers.ts';

import { useDealContext } from '../utils/context/DealContext.tsx';

import { DealsFastFiltersTopBar } from './DealsFastFiltersTopBar.tsx';
import { DealsTable, type DealsTableProps } from './DealsTable.tsx';

//TODO: UIG-540 Stipe Move to deal Lib

export interface DealListProps<T extends ListDealBase = ListDeal> {
  changeFilters: (filters: DealsListFiltersValue) => void;
  changeSingleCriteriaDimension;
  filtersConfig: FiltersConfig;
  toggleSelect: ToggleSelect<T>;
  useDealsRowActions: DealsTableProps<T>['useDealsRowActions'];
  onRowClick?: RowAction<T>;
  criteria: AllTableCriteria;
  dealsList: T[];
  selectedData: T[];
  loading: boolean;
  topManagementSection?: DealsTableProps<T>['topManagementSection'];
  dealIdFilterKey?: 'exchange_deal_id' | 'deal_id';
  dealIdsToGroup?: string[];
}

export function DealsList<T extends ListDealBase = ListDeal>({
  changeFilters,
  changeSingleCriteriaDimension,
  toggleSelect,
  criteria,
  loading,
  dealsList,
  filtersConfig,
  selectedData,
  useDealsRowActions,
  topManagementSection,
  dealIdFilterKey = 'deal_id',
  dealIdsToGroup,
  onRowClick,
}: DealListProps<T>) {
  const updateDealIdFilter = (filterValue?: string) => {
    const currentFilters = criteria.filters as DealsListFiltersValue;

    changeFilters({ ...currentFilters, [dealIdFilterKey]: filterValue });
  };

  const { useDealsTableFetch } = useDealContext();
  const { columns } = useDealsTableFetch(undefined, undefined, {
    dealIdsToGroup,
    updateDealIdFilter,
  });

  return (
    <>
      <DealsFastFiltersTopBar
        onChange={changeFilters}
        criteria={criteria}
        filtersConfig={filtersConfig}
        dealIdFilterKey={dealIdFilterKey}
      />
      <DealsTable<T>
        onCriteriaChange={changeSingleCriteriaDimension}
        onRowClick={onRowClick}
        toggleSelect={toggleSelect}
        loading={loading}
        selectedData={selectedData}
        dealsList={dealsList}
        criteria={criteria}
        columns={columns}
        useDealsRowActions={useDealsRowActions}
        topManagementSection={topManagementSection}
      />
    </>
  );
}
